export default __webpack_public_path__ + "static/media/Analog_3_Pin_Output@2x.e7d6b9fd.png";